import { Helmet } from "react-helmet-async";

const SITE = "https://noxaiapp.com";
const DEFAULT_IMAGE = `${SITE}/og-image.png`;

/**
 * Reusable SEO head manager. Drop into any page.
 * - title/description drive the SERP snippet + social cards
 * - path builds the canonical URL
 * - noindex hides auth-gated/app pages from crawlers
 * - jsonLd injects structured data for rich results
 */
export function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  noindex = false,
  type = "website",
  jsonLd,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | Nox AI` : "Nox AI — Your all-in-one AI creative studio";

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"}
      />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Nox AI" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
